<template>
  <header class="header">
    <div class="inner">
      <div class="utility-wrap">
        <ul class="utility-list">
          <!-- 로그인 전 -->
          <li class="sign-in" v-if="!isLoggedIn">
            <button type="button" @click="handleLoginClick">로그인&#47;회원가입</button>
          </li>
          <!-- // 로그인 전 -->
          <!-- 로그인 후 -->
          <li class="sign-up" v-if="isLoggedIn">
            <NuxtLink to="/pc/mypage" class="link-sign-up">
              <img class="grade-info" :src="userGradeImgSrc" alt="">
              {{ userName }}님
            </NuxtLink>
            <div class="dropdown-menu-wrap">
              <ul class="dropdown-menu-list">
                <li><span class="title">주문관리</span></li>
                <li><NuxtLink to="/pc/mypage/order">구매관리</NuxtLink></li>
                <li><NuxtLink to="/pc/mypage/pin-publication-request">핀발행 요청 관리</NuxtLink></li>
              </ul>
              <ul class="dropdown-menu-list">
                <li><span class="title">결제관리</span></li>
                <li><NuxtLink to="/pc/mypage/hcash">H캐시 관리</NuxtLink></li>
                <li><NuxtLink to="/pc/mypage/mileage">적립금 관리</NuxtLink></li>
                <li><NuxtLink to="/pc/mypage/account">계좌 관리</NuxtLink></li>
              </ul>
              <ul class="dropdown-menu-list">
                <li><span class="title">쿠폰 발송 관리</span></li>
                <!-- <li><NuxtLink to="/pc/mypage/sender">발신번호 관리</NuxtLink></li> -->
                <li><NuxtLink to="/pc/mypage/coupon-top-image">쿠폰 상단 이미지 관리</NuxtLink></li>
                <li><NuxtLink to="/pc/mypage/coupon-message">쿠폰 메시지 관리</NuxtLink></li>
                <li><NuxtLink to="/pc/mypage/receive-person">연락처 관리</NuxtLink></li>
              </ul>
              <ul class="dropdown-menu-list">
                <li><span class="title">나의 정보 관리</span></li>
                <li><NuxtLink to="/pc/mypage/information">회원 정보 관리</NuxtLink></li>
                <!-- 로그아웃만 css 적용 안되어서 style 추가함 -->
                <li @click="logout()" style="color: #666; cursor: pointer;">로그아웃</li>
              </ul>
            </div>
          </li>
          <!-- // 로그인 후 -->
          <li class="cs-center">
            <NuxtLink to="/pc/inquiry/list">고객센터</NuxtLink>
          </li>
        </ul>
      </div>

      <div class="header-search-warp">
        <div class="logo-area">
          <NuxtLink to="/pc/product/main" @click="changeSearchWordHome('')">
            <img
              src="@/assets/images/pc/header-logo.png"
              alt="Hcon 현대이지웰 로고"
            />
          </NuxtLink>
        </div>
        <div class="search-area">
          <div class="search-bar-wrap">
            <div
              class="search-box"
              :class="{ on: isSearchBoxOpen }"
              @mouseleave="closeSearchBox"
            >
              <form action="" @submit.prevent="" method="get" class="inp-search-group">
                <label for="" class="a11y-blind">검색</label>
                <input
                  type="text"
                  id=""
                  v-model="inputProductContidion" 
                  name=""
                  class="inp-search"
                  @click="handleSearchBox"
                  @keydown="handleSearchConditionLength"
                  placeholder="Hcon 오픈! 오늘 당신을 위한 추천 상품은?"
                />
                <button type="submit" class="search-btn" @click="searchProduct">
                  <img
                    src="@/assets/images/pc/icon-hcon/icon-search.svg"
                    alt="검색"
                  />
                </button>
              </form>
              <div class="integration-search-box">
                <div class="search-list-box">
                  <div class="search-title">
                    <h3>최근검색어</h3>
                    <a class="all-delete-btn" @click="deleteRecentSearchwordsAll">전체삭제</a>
                  </div>
                  <ul class="recent-search-list">
                    <li v-for="item in recentSearchwordsInfo" :key="item.rcntScwdSeq" class="tag-li">
                      <HconComPCTag @:click="changeSearchWord(item.rcntScwd)" :linkTag="true" :text="item.rcntScwd" :deleteType="'recentSearchword'" :value="item.rcntScwdSeq"/>
                    </li>
                  </ul>
                  <div class="search-title">
                    <h3>추천검색어</h3>
                    <span class="search-date">{{ HconCommonUtils.format.dateTime(baseDate) }} 기준</span>
                  </div>
                  <ol class="recommend-search-list">
                    <li 
                      v-for="item in recommendationSearchwordsInfo" :key="item.rcmmScwdSeq">
                      <!--TODO 추후에 추천검색어 클릭 시 해당 추천검색어로 상품목록 조회 화면 이동-->
                      <NuxtLink @:click="changeSearchWord(item.rcmmScwd)">
                        <span class="num">{{ item.rcmmScwdRank }}</span>
                        {{ item.rcmmScwd }}
                      </NuxtLink>
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <div class="top-icon-area">
            <ul class="icon-list">
              <li class="cart">
                <NuxtLink to="/pc/order/basket">
                  <img
                    src="@/assets/images/pc/icon-hcon/icon-cart.svg"
                    alt="장바구니"
                  />
                  <!-- 로그인 후 -->
                  <!-- TODO 사용자장바구니목록 갯수 가져와야됨-->
                  <span class="num" v-if="isLoggedIn">{{ bsktCnt }}</span>
                  <!-- // 로그인 후 -->
                </NuxtLink>   
              </li>
              <li class="temp-save">
                <NuxtLink to="/pc/order/temp-save">
                  <img
                    src="@/assets/images/pc/icon-hcon/icon-temp-save.svg"
                    alt="임시저장"
                  />
                  <!-- 로그인 후 -->
                  <!-- TODO 사용자임시저장목록 갯수 가져와야됨-->
                  <span class="num" v-if="isLoggedIn">{{ tmpOrdCnt }}</span>
                  <!-- // 로그인 후 -->
                </NuxtLink>
              </li>
              <!-- TODO 온라인견적서 연결-->
              <li class="estimate">
                <NuxtLink to="/pc/order/estimate">
                  <img
                    src="@/assets/images/pc/icon-hcon/icon-estimate.svg"
                    alt="견적서"
                  />
                </NuxtLink>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="gnb-area" :class="{ 'has-border': hasBorder }">
      <div class="inner">
        <div class="gnb-wrap" :class="{ on: isMenuOpen }">
          <!-- 햄버거 아이콘 옆 메인 기획전명 및 기타 메뉴 노출 영역 -->
          <div class="menu-area">
            <button
              type="button"
              class="all-menu-btn"
              aria-label="전체 메뉴"
              @click="handleNav"
            ></button>
            <nav class="gnb-menu">
              <ul
                class="gnb-menu-list"
              >
                <li
                  v-for="(menu, menuIndex) in gnbWrapMenu"
                  :key="menuIndex"
                >
                  <NuxtLink
                    :to="menu.link"
                    :style="{
                      color: menu.color,
                      'font-weight': menu.fontWeight,
                    }"
                    >{{ menu.text }}</NuxtLink>
                </li>
                <!-- 로그인 후 -->
                <li v-if="isLoggedIn"><NuxtLink to="/pc/pin-publication-request">핀발행</NuxtLink></li>
                <!-- // 로그인 후 -->
              </ul>
            </nav>
          </div>
          <!-- 햄버거 아이콘 클릭 시 노출 -->
          <div
            class="sub-menu-area"
            @mouseenter="handleMouseEnter"
            @mouseleave="handleMouseLeave"
          >
            <ul class="depth1-menu-list">
              <li
                :class="{ on: currentCategory === menu.id }"
                v-for="menu in depth1Menus"
                :key="menu.id"
                @mouseenter="changeCategory(menu.id)"
              >
                <NuxtLink :to="menu.link" @click.prevent="getDepth(menu)">{{ menu.text }}</NuxtLink>
              </li>
            </ul>
            <div class="depth2-menu-area" :class="{ active: showDepth2 }">
              <div class="menu-list-wrap">
                <ul
                  class="depth2-menu-list"
                  v-for="(column, index2) in depth2MenuCloumns"
                  :key="index2"
                >
                  <li v-for="depth2 in column" :key="depth2.id"
                    @mouseenter="changeDepth2Category(depth2.id)"
                    :class="{ active: currentDepth2?.id === depth2.id && showDepth3 }"
                  >
                    <NuxtLink :to="depth2.link" @click.prevent="getDepth(depth2)">{{ depth2.text }}</NuxtLink>
                  </li>
                </ul>
              </div>
            </div>
            <div class="depth3-menu-area" :class="{ active: showDepth3 }">
              <div class="menu-list-wrap">
                <ul
                  class="depth3-menu-list"
                  v-show="showDepth3"
                  v-for="(depth3Column, index3) in depth3MenuCloumns"
                  :key="index3"
                >
                  <li v-for="depth3 in depth3Column" :key="depth3.id">
                    <NuxtLink :to="depth3.link" @click.prevent="getDepth(depth3)">{{ depth3.text }}</NuxtLink>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="top-noti-area">
            <!-- 메뉴배너 페이지 이동 -->
            <NuxtLink class="event-page">
              <img :src="menuBnnrImgPath" alt="메뉴배너" @:click="moveBannerPage(menuBnnrSeq, menuBnnrNwinMvYn, menuBnnrShctUrl)">
            </NuxtLink>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>
<script setup lang="ts">
import { ref, computed, watch, onMounted } from "vue";
import HconComPCTag from "@/components/com/HconComPCTag.vue";
import { usePopup  } from "@/composables/hconUsePopup";
import gradeF from '@/assets/images/pc/icon-hcon/grade-F.png';
import gradeG from '@/assets/images/pc/icon-hcon/grade-G.png';
import gradeP from '@/assets/images/pc/icon-hcon/grade-P.png';
import type { UserCommonInfoDto } from "~/types/mypage/backend-dto-types";
import type { RecommendationsearchwordsDto, DisplayMainHeaderInfo, CategoryBrandMappingDto, RecentsearchwordsDto } from "~/types/display/backend-dto-types";
import { COMMON_CODE } from "~/constants/hconMessageConstants";
import SessionStorageSynchronizer from '~/utils/sync-sessionstorage';

const isMenuOpen = ref(false);
const isSearchBoxOpen = ref(false);

// 사용자고유번호 세션 값 세팅
const userKey = ref(useHconAuthInfo().getIfPossible()?.userContext.userKey);

// 회원 이름 세션 값 세팅
const userName = ref("")

// 추천 검색어 기준(가장 마지막에 수정된 날짜) => 노출시간 기준 필요...
const baseDate = ref()

// 메뉴 배너 (카테고리 바로가기 위에 나오는 배너)
const menuBnnrImgPath = ref("");
const menuBnnrShctUrl = ref("");
const menuBnnrNwinMvYn = ref("");
const menuBnnrSeq = ref(0);

const fetchBuilder = useHconFetchBuilder();
const router  = useRouter();
const inputProductContidion = ref("")
const { bsktCnt, tmpOrdCnt, setBsktCnt, setTmpOrdCnt, recentSearchwordsInfo, refreshRecentSearchwords } = useHeader()
// 초기호출
onMounted(async () => {
  if(useHconAuthInfo().getIfPossible()){
    userName.value = useHconAuthInfo().getIfPossible()?.userContext?.name?? '';
    isLoggedIn.value = true;
    // 마이페이지 공통 상단 정보 조회
    usercommonInfo();
    // 최근검색어 목록 조회
    refreshRecentSearchwords();
  }

  // 추천검색어 목록 조회
  recommendationSearchwords();
  // 메뉴 배너 조회
  getMenuBnnr();
  // 카테고리-브랜드 매핑 조회, 메인 기획전명 조회
  getDisplayMainHeaderInfo();

})

watch (recentSearchwordsInfo, (newVal, olVal) =>{

})
// 마이페이지 공통 상단 정보 조회 API 결과 값
const commonInfo = ref<UserCommonInfoDto>();
// 최근검색어 목록 조회 API 결과 값

// 추천검색어 목록 조회 API 결과 값
const recommendationSearchwordsInfo = ref<RecommendationsearchwordsDto[]>();

// 등급 이미지 
const imageMap: Record<string, string> = {
  FRIENDS: gradeF,
  GOLD: gradeG,
  PLATINUM: gradeP
}

// 사용자등급명에 따른 등급이미지 url 호출
const userGradeImgSrc = computed(() => {
  if(commonInfo.value?.userGradeDto) {
    return imageMap[commonInfo.value.userGradeDto.hcUsrGrdNm]
  }
});

// 메뉴 배너 조회 (단건)
const getMenuBnnr = async () => {
  const res = await fetchBuilder
    .get<AjaxResult<any>>('/api/v1/product/display/get-banner-image/1006')
    .progressMessage("잠시만 기다려주세요...")
    .build()
    .execute()
    .then((result) => {
      // 응답코드가 200이 아닌경우
      if(result.resultCode != '200') {
        showAlert(result.resultMessage)
      }
      else {
        if(!result?.data) return;

        if(result?.data.bnnrImgPath) {
         menuBnnrImgPath.value = cu.getFileFullUrl(result.data.bnnrImgPath)
        } 
        menuBnnrShctUrl.value = result.data.bnnrShctUrl??'';
        menuBnnrNwinMvYn.value = result.data.nwinMvYn??'';
        menuBnnrSeq.value = result.data.bnnrSeq??'';
      }
    }) 
}

// 카테고리-브랜드 매핑 조회 (햄버거 아이콘 클릭 시 노출)
// 메인 기획전명 조회 (햄버거 아이콘 옆 노출)
const getDisplayMainHeaderInfo = async () => {
  fetchBuilder.get<AjaxResult<DisplayMainHeaderInfo>>('/api/v1/product/display/main-header')
    .progressMessage("잠시만 기다려주세요...")
    .build()
    .execute()
    .then((result) => {
      if(result.resultCode != '200') {
        showAlert(result.resultMessage);
      } else {
        // 카테고리-브랜드 매핑 세팅
        categoryBrandList.value = result.data.ctgrBrndMappingList;
        // 메인 기획전명 세팅
        gnbWrapMenu.value = [
          ...result.data.mainPrmList.map(prm => {
            return {
              text: prm.mainPageExpsMenuNm,
              link: `/pc/product/promotion/detail/${prm.prmCd}`,
              color: '#222',
              fontWeight: '400'
            }
          }),
          { text: '대량구매', link: "/pc/product/search?searchMassCd=mass&t="+ Date.now(), color: '#222', fontWeight: '400' }, // 고정 노출 항목
          { text: '추천 베스트', link: '/pc/product/search?searchMassCd=best100&t='+ Date.now(), color: '#222', fontWeight: '400' }, // 고정 노출 항목
          { text: '기획전', link: '/pc/product/promotion/list', color: '#222', fontWeight: '400' }, // 고정 노출 항목
        ]
      }
  });
}

interface BreadcrumbItem {
  label : string        // 화면에 보여질 브래드크럼명 ex) 홈 > 마이 Hcon
  to: string            // 브래드크럼명 클릭 시 이동되는 경로(useRoute를 이용하여 자동으로 파일 폴더 경로대로 지정됨) ex) pc/mypage
  child?: any[]         // 하위 자식들 ex) pc/mypage의 경우 해당 경로 하위에 있는 값 들(구매관리, 핀발행 요청 관리, H캐시 관리 등) 
  category?: boolean    // 추후 상품목록에서 카테고리, 브랜드 별로 필터링 시 사용될 값
  hideChild?: boolean   // 하위 자식들 숨김 여부 ex) true => pc/mypage 자식들이 드롭다운으로 안보여짐
  skipParent?: string[] // 중간에 skip할 부모 브래드크럼들 => ex) ['마이 Hcon', '회원 정보 관리'] => 회원탈퇴 완료 페이지에서 해당 부모 브래드크럼을 skip
  movable?: boolean     // 브래드크럼명 클릭 시 이동 여부 => ex) 기획전 목록, 기획전 상세 페이지의 경우 브래드크럼 클릭 시 해당 경로로 이동 x
  id? : string
  depth?: number
  highCategoryId?: string
  categoryId?: string
  brandId? : string
}

const getDepth = (breadcrumb : any) => {
  sessionStorage.removeItem("product.highCategoryCd")
  sessionStorage.removeItem("product.categoryCd")
  sessionStorage.removeItem("product.brandCd")
  
  const foundDepth1 = treeData.value.find(v => v.id == breadcrumb.highCategoryId)

  if (!foundDepth1) return

  currentDepth1.value = foundDepth1

  const foundDepth2 = foundDepth1.children.find((v: { id: string; }) => v.id === breadcrumb.categoryId)

  if (foundDepth2) {
    currentDepth2.value = foundDepth2

    const foundBrand = foundDepth2.brands.find(
      (b: Brand) => b.id === breadcrumb.brandId
    )

    if (foundBrand) {
      currentBrand.value = foundBrand
    }
  } else {
    const foundBrand = foundDepth1.brands.find(
      (b: Brand) => b.id === breadcrumb.brandId
    )

    if (foundBrand) {
      currentBrand.value = foundBrand
    }
  }

  if (breadcrumb.depth ===1) {
    sessionStorage.setItem("product.highCategoryCd", JSON.stringify(currentDepth1.value))
  } else if (breadcrumb.depth ===2) {
    sessionStorage.setItem("product.highCategoryCd", JSON.stringify(currentDepth1.value))
    sessionStorage.setItem("product.categoryCd",JSON.stringify(currentDepth2.value))
  } else if (breadcrumb.depth ===3) {
    sessionStorage.setItem("product.highCategoryCd", JSON.stringify(currentDepth1.value))
    sessionStorage.setItem("product.categoryCd",JSON.stringify(currentDepth2.value))
    sessionStorage.setItem("product.brandCd", JSON.stringify(currentBrand.value))
  }
}
// 배너 클릭 시 클릭횟수 업데이트 및 화면 제어 (새창이동 또는 화면 전환)
const moveBannerPage = async (bnnrSeq: number, nwinMvYn: string, link: string) => {
  if(bnnrSeq>0 && nwinMvYn != '' && link != ''){
    const res = await fetchBuilder
    .put<AjaxResult<void>>(`/api/v1/product/display/banner-click-count/${bnnrSeq}`)
    .build()
    .execute()
    .then(async (result) => {
      if(result.resultCode != '200') {
        showAlert(result.resultMessage);
      } else {
        if (nwinMvYn === 'Y') {
          // 새 창으로 이동
          window.open(link, '_blank');
        } else {
          router.push(link);
        }
      }
    })
  }
}

// 햄버거 아이콘 옆에 노출되는 메인 메뉴 Data
interface gnbWrapMenuData {
  text: string
  link: string
  color: string
  fontWeight: string
}

const gnbWrapMenu = ref<gnbWrapMenuData[]>();

const props = defineProps({
  hasBorder: {
    type: Boolean,
    default: false,
  },
  hasBreadcrumbs: {
    type: Boolean,
    required: false,
  },
  breadcrumbsRef: {
    type: Object as PropType<any>,
    required: false,
  },
});

// nav 메뉴 클릭
const handleNav = () => {
  isMenuOpen.value = !isMenuOpen.value;
  currentCategory.value ='';
  currentDepth2.value = null;
  showDepth2.value = false;
  showDepth3.value = false;
};

const handleMouseLeave = () => {
  isMenuOpen.value = false;
  showDepth2.value = false;
  showDepth3.value = false;
};

// 통합 검색 클릭
const handleSearchBox = () => {
  isSearchBoxOpen.value = !isSearchBoxOpen.value;
};

const handleSearchConditionLength = () => {
  if(inputProductContidion.value != '' && inputProductContidion.value  != undefined) {
  inputProductContidion.value = inputProductContidion.value.substring(0,20);
  }
}

watch(inputProductContidion, (newV, oldV) => {
  if(inputProductContidion.value != '' && inputProductContidion.value  != undefined) {
    inputProductContidion.value = newV.substring(0,20);
  }
})


const closeSearchBox = () => {
  isSearchBoxOpen.value = false;
};

// 카테고리-브랜드 조회 결과 리스트 (햄버거 아이콘 클릭 시 노출)
const categoryBrandList = ref<CategoryBrandMappingDto[]>([]);
const buildCategoryTree = (list: CategoryBrandMappingDto[]) => {
  const lvl1Map = new Map();

  list.forEach(row => {
    // ======================================================
    // 1 레벨 카테고리 세팅
    // ======================================================
    if (!lvl1Map.has(row.frstCtgrCd)) {
      lvl1Map.set(row.frstCtgrCd, {
        id: row.frstCtgrCd,
        name: row.frstCtgrNm,
        sort: row.frstCtgrSortOrdg,
        to: '/pc/product/search?searchHighCategory=' + row.frstCtgrCd + "&t=" + Date.now(),
        children: [],
        brands: [],
        _brandSet: new Set<string>()
      })
    }

    const lvl1 = lvl1Map.get(row.frstCtgrCd);

    // ======================================================
    // 2 레벨 있는 경우 카테고리 세팅
    // ======================================================
    if (row.sndCtgrCd) {
      let lvl2 = lvl1.children.find(
        (c: any) => c.id === row.sndCtgrCd
      )

      if (!lvl2) {
        lvl2 = {
          id: row.sndCtgrCd,
          name: row.sndCtgrNm,
          sort: row.sndCtgrSortOrdg,
          to: '/pc/product/search?searchHighCategory='+row.frstCtgrCd+'&searchCategory='+row.sndCtgrCd + "&t=" + Date.now(),
          brands: [],
          _brandSet: new Set<string>()
        }
        lvl1.children.push(lvl2);
      }

      // ======================================================
      // 브랜드 있는 경우 브랜드 세팅
      // ======================================================
      if (row.brndCd && !lvl2._brandSet.has(row.brndCd)) {
        lvl2._brandSet.add(row.brndCd);
        lvl2.brands.push({
          id: row.brndCd,
          name: row.brndNm,
          sort: row.brndSortOrdg,
          to: '/pc/product/search?searchHighCategory='+row.frstCtgrCd+'&searchCategory='+row.sndCtgrCd+'&searchBrand='+row.brndCd + "&t=" + Date.now(),
        })
      }
    } else {
      // ======================================================
      // 2 레벨 없는 경우 → 1레벨 브랜드 있는 경우 세팅
      // ======================================================
      if (row.brndCd && !lvl1._brandSet.has(row.brndCd)) {
        lvl1._brandSet.add(row.brndCd);
        lvl1.brands.push({
          id: row.brndCd,
          name: row.brndNm,
          sort: row.brndSortOrdg,
          to: '/pc/product/search?searchHighCategory='+row.frstCtgrCd+'searchBrand='+row.brndCd + "&t=" + Date.now()
        })
      }
    }
  })

  // ======================================================
  // 정렬 및 정리
  // ======================================================
  return Array.from(lvl1Map.values()).sort((a, b) => a.sort - b.sort).map(lvl1 => {
    lvl1.children.sort((a: any, b: any) => a.sort - b.sort);

    lvl1.children.forEach((lvl2: any) => {
      lvl2.brands.sort((a: any, b: any) => a.sort - b.sort);
      delete lvl2._brandSet;
    });

    lvl1.brands.sort((a: any, b: any) => a.sort - b.sort);

    delete lvl1._brandSet;
    return lvl1;
  })
}

// 카테고리-브랜드 매핑 트리 데이터 (전체 데이터)
const treeData = computed(() =>  buildCategoryTree(categoryBrandList.value));

type Brand = {
  id: string
  name: string
  sort: number
  to: string
}

type Depth2 = {
  id: string
  name: string
  sort: number
  to: string
  brands: Brand[]
}

type Depth1 = {
  id: string
  name: string
  sort: number
  to: string
  children: Depth2[]
  brands: Brand[]
}

const currentDepth1 = ref<Depth1 | null>(null);
const currentDepth2 = ref<Depth2 | null>(null);
const currentBrand = ref<Brand | null>(null);
const showDepth2 = ref<boolean>(false);
const showDepth3 = ref<boolean>(false);

watch(
  ()=> useRoute().fullPath,
  () => {
    // alert(useRoute().query.searchWords)
    // const searchParams = getQuery(useRoute().query.searchWords)
    if(useRoute().query.searchWords != ''){
      inputProductContidion.value = cu.getFirst(useRoute().query.searchWords)
    } else {
      inputProductContidion.value = ''
    }
  }
)

const getQuery = (v: any) => {
  if(v === undefined || v === null) return ''
  return Array.isArray(v) ? v[0] : String(v)
}
// depth 에 따라 세팅
const depth1Menus = computed(() =>
  treeData.value.map(lvl1 => ({
    text: lvl1.name,
    link: lvl1.to,
    id: lvl1.id,
    depth : 1,
    highCategoryId: lvl1.id
  }))
)


const depth2MenuCloumns = computed(() => {

  if (!currentDepth1.value) return [];

  const children = currentDepth1.value.children;
  if (!children.length) return [];

  return [
    children.map(item => ({
      id: item.id,
      text: item.name,
      link: item.to,
      brands: item.brands,
      depth : 2,
      highCategoryId: currentDepth1.value?.id,
      categoryId :  item.id,
    }))
  ]
})

const depth3MenuCloumns = computed(() => {
  if (!currentDepth2.value) return [];

  const brands = currentDepth2.value.brands || [];

  return [
    brands.map(b => ({
      id: b.id,
      text: b.name,
      link: b.to,
      depth : 3,
      highCategoryId: currentDepth1.value?.id,
      categoryId :  currentDepth2.value?.id,
      brandId : b.id,
    }))
  ]

})

const currentCategory = ref<string>("");
const changeCategory = (id: string) => {
  const found = treeData.value.find(v => v.id === id);
  if (!found) return

  currentDepth1.value = found;
  showDepth2.value = true;

  currentCategory.value = id;

  // 2레벨 없는 경우 바로 depth3 세팅
  if (!found.children.length) {
    currentDepth2.value = {...found, brands: found.brands} as any;
    showDepth3.value = true;
  } else {
    showDepth3.value = false;
  }
}

const changeDepth2Category = (id: string) => {
  if (!currentDepth1.value) return;

  const found = currentDepth1.value.children.find(v => v.id === id);
  if (!found) return;

  currentDepth2.value = found;
  showDepth3.value = true;
}

// 마우스 올렸을 경우 2depth 보여짐
const handleMouseEnter = (): void => {
  showDepth2.value = true;
};

// 전역 팝업 설정
const { openLoginPopup, isLoggedIn, showConfirm, showAlert} = usePopup()

// 로그인 팝업 click 이벤트
const handleLoginClick = () => {
  openLoginPopup()
}

// 마이페이지 공통 상단 정보 조회 API 호출
const usercommonInfo = async () => {
  userKey.value = useHconAuthInfo().getIfPossible()?.userContext.userKey;

  await fetchBuilder.get<AjaxResult<UserCommonInfoDto>>('/api/v1/mypage/common/userCommonInfo')
  .query({
    userKey: userKey,
  })
  .progressMessage("잠시만 기다려주세요...")
  .build()
  .execute()
  .then((result) => {
    // 응답코드가 200이 아닌경우
    if(result.resultCode != '200') {
      showAlert(result.resultMessage)
    }
    else {
      commonInfo.value = result.data
      
      if(commonInfo.value.userProductDto) {
        setBsktCnt(commonInfo.value.userProductDto.bsktCnt)
        setTmpOrdCnt(commonInfo.value.userProductDto.tmpOrdCnt)
      }
    }
  }) 
}

// 최근검색어 모두 삭제 API 호출
const deleteRecentSearchwordsAll = async () => {
  if(isLoggedIn.value === true) {
    const fetchBuilderResult = 
    await fetchBuilder.delete<AjaxResult<number>>('/api/v1/product/display/recent-searchwords-delete-all')
    .body()
    .build()
    .execute()
    .then((result) => {
      if(result.resultCode == '200') {
        const searchItems = document.querySelectorAll(".tag-item");
        searchItems.forEach(function (item) {
          item.remove();
        });
      }
    })
    .catch((error) => {
      // 응답코드가 200이 아닌경우
      if(error.resultCode != '200') {
        showAlert(error.resultMessage)
      }
    })
  }
}

const changeSearchWordHome = (rcmmScwd:string) => {
  inputProductContidion.value = rcmmScwd
}

const changeSearchWord = (rcmmScwd:string) => {
  inputProductContidion.value = rcmmScwd

  searchProduct();
}

// 추천검색어 목록 조회 API 호출
const recommendationSearchwords = async () => {
  const fetchBuilderResult = 
  await fetchBuilder.get<AjaxResult<RecommendationsearchwordsDto[]>>('/api/v1/product/display/recommendation-searchwords/list')
  .query()
  .progressMessage("잠시만 기다려주세요...")
  .preventErrorNotify()
  .build()
  .execute()
  .then((result) => {
    if(result.resultCode == '200') {
      recommendationSearchwordsInfo.value = result.data
      const lastModDtm = recommendationSearchwordsInfo.value.toSorted((b:any, a:any) => a.lastModDtm - b.lastModDtm)[0]
      baseDate.value = lastModDtm.lastModDtm
    }
  })
  .catch((error) => {
    // 응답코드가 200이 아닌경우
    if(error.resultCode != '200') {
      showAlert(error.resultMessage)
    }
  })
}

// 로그아웃 API 호출
const logout = async() => {
  const result = await showConfirm({
    title: '로그아웃',
    message: "로그아웃하시겠습니까?",
    confirmText: '확인',
    cancelText: '취소'
  })

  if (result) {
    fetchBuilder.post<AjaxResult<any>>('/api/v1/member/auth/logout')
        .body({
          accessToken : useHconAuthInfo().getIfPossible()?.accessToken,
          refreshToken : useHconAuthInfo().getIfPossible()?.refreshToken
        })
        .build()
        .execute()
        .then((result) => {
            if(result.resultCode == "200")  {

              isLoggedIn.value = false;
              localStorage.setItem('common.auth.isRememberMe','N');
              useHconAuthInfo().clear();
              const { $start27Timer, $stopTimer } = useNuxtApp();
              $stopTimer();
              recentSearchwordsInfo.value = [];
              //window.location.reload();
              // useRouter().go(0)
              navigateTo({path: '/pc/product/main'}, {replace:true});
              localStorage.setItem('auth:event', JSON.stringify({
                  type: 'LOGOUT',
                  at: Date.now()
              }));             
            }
        })
   }
}

watch(isLoggedIn, (newV, oldV) => {
  if(newV === true) {
    if(HconCommonUtils.isEmpty(useHconAuthInfo().getIfPossible()?.userContext?.name)){
      isLoggedIn.value = false;
    } else {
      userName.value = useHconAuthInfo().getIfPossible()?.userContext?.name?? '';
      usercommonInfo();
      isLoggedIn.value = true;
    }
  }

})

const searchProduct = () => { 
  if(inputProductContidion.value == '' || inputProductContidion.value == undefined || inputProductContidion.value == null) {
    showConfirm({message:  HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "검색어를", "입력")})
    return false;
  }
  
  if(!HconCommonUtils.isEmpty(useHconAuthInfo().getIfPossible()?.userContext?.userKey)){
    fetchBuilder.post<AjaxResult<any>>('/api/v1/product/display/recent-searchwords/create')
      .body({
        rcntScwd : inputProductContidion.value,
      })
      .build()
      .execute()
      .then((result) => {
        refreshRecentSearchwords()
        navigateTo({path: '/pc/product/search', query:{searchWords: inputProductContidion.value, t: Date.now()}}, {replace: true})
      })
  } else {
    navigateTo({path: '/pc/product/search', query:{searchWords: inputProductContidion.value, t: Date.now()}}, {replace: true})
  }

  
}
</script>
<style lang="scss" scoped>
</style>
